var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text__img-box"},[_c('prismic-image',{attrs:{"img":_vm.data.image}}),_vm._v(" "),_c('div',{staticClass:"content",class:_vm.align,domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.data.content))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }